import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { ClipboardCheck } from "lucide-react";

/**
 * Industrial-DS Footer (TES-967, D5) nach Stitch-Mock screen-12 —
 * markenfixe Deep-Blue-Fläche (TES-1032: bg-brand statt bg-inverse-surface,
 * damit der Footer im Dark Mode nicht hell invertiert), Safety-Yellow-Wortmarke,
 * reale Routen (Impressum/Datenschutz).
 */
export function LandingFooter() {
  const { t } = useTranslation();

  return (
    <footer className="flex w-full flex-col items-center justify-between gap-8 border-t border-brand-container bg-brand px-4 py-12 text-white sm:px-6 md:flex-row lg:px-8">
      <div className="flex flex-col items-center gap-2 md:items-start">
        <span className="flex items-center gap-2 font-display text-lg font-semibold text-secondary-fixed">
          <ClipboardCheck className="h-5 w-5" />
          CheckMaty
        </span>
        <p className="max-w-xs text-center text-sm text-white/60 md:text-left">
          © {new Date().getFullYear()} CheckMaty. {t("landing.industrial.footer.tagline")}
        </p>
      </div>

      <nav className="flex flex-wrap justify-center gap-6 text-sm">
        <Link to="/imprint" className="text-white/70 transition-colors hover:text-white">
          {t("landing.footer.imprint")}
        </Link>
        <Link to="/privacy" className="text-white/70 transition-colors hover:text-white">
          {t("landing.industrial.footer.privacy")}
        </Link>
      </nav>
    </footer>
  );
}
